<template>
  <img :src="logoCia()"/>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      default: null
    },
    small: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials'
    })
  },
  methods: {
    logoCia() {
      let url = this.urlBase + 'companias/logo?id=' + this.id + "&token=" + this.credentials.token;
      if (this.small) {
        url += "&size=small";
      }

      return url;
    }
  }
}
</script>

